/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cases_Filter_ResolvedInputs */

const en_cases_filter_resolved = /** @type {(inputs: Cases_Filter_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolved`)
};

const pt_br2_cases_filter_resolved = /** @type {(inputs: Cases_Filter_ResolvedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resolvido`)
};

/**
* | output |
* | --- |
* | "Resolved" |
*
* @param {Cases_Filter_ResolvedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const cases_filter_resolved = /** @type {((inputs?: Cases_Filter_ResolvedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cases_Filter_ResolvedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cases_filter_resolved(inputs)
	return pt_br2_cases_filter_resolved(inputs)
});